<template>
  <div class="sched-form-wrap" v-if="renderForm">
    <div class="modal-header">
      <div>
        <div class="d-none d-md-flex">
        <h1 class="page-title">{{ headerCode ? originalData[headerCode] : t(def.dictionaryKeyCode) }}</h1>
        <div
        v-if="editorIcons.length || def.listImages.length"
        class="d-inline pl-4 pt-1" style="">
        <icons-render v-if="editorIcons.length" :propIcons="editorIcons"/>
        <!--      <images-render v-if="def.listImages.length" :propImages="def.listImages"/>-->
      </div>

      </div>
        <div class="mb-15" v-if="subHeaders && originalData && subHeaders.length > 1">
          <div v-for="(subHeader, index) in subHeaders" :key="index">
            <icons-render v-if="subHeader instanceof Object" :propIcons="[{
              def: {},
              value: subHeader
            }]"/>
            <span v-else>{{ subHeader }}</span>
          </div>
        </div>
      </div>

      <div class="modal-header-content">

        <!-- BACK -->
        <button
          @click="cancelListener"
          type="button"
          class="btn btn-icon btn-dark btn-close"
          aria-label="Close">
          <i class="icon wb-close"></i>
        </button>

        <!-- SUBMIT -->
        <button
          @click="submit(false, true)"
          class="btn-save-data hidden"
          type="button">
        </button>

        <button
          @click="submit(false, true)"
          class="btn btn-icon btn-primary"
          v-bind:class="{disabled: def.isReadOnly === 'true'}"
          :disabled="!dataChanged || def.isReadOnly === 'true'"
          type="button">
          <i class="icon pe-diskette"></i>
        </button>

        <button
          @click="submit(true)"
          class="btn btn-icon btn-success"
          v-bind:class="{disabled: def.isReadOnly === 'true'}"
          :disabled="!dataChanged || def.isReadOnly === 'true'"
          type="button">
          <i class="icon wb-check"></i>
        </button>
      </div>
      <div class="nav-tabs-horizontal nav-tabs-inverse d-none">
        <ul class="nav nav-tabs nav-tabs-solid" role="tablist" id="tab-holder" ref="tabHolder">
          <li class="nav-item" role="presentation">
            <a
              @click="_renderBaseForm"
              v-if="innerSubForms.length"
              class="nav-link"
              v-bind:class="{'active': renderBaseForm}"
              data-toggle="tab"
              href="#Heading"
              aria-controls="tabHeading"
              role="tab"
              ref="formHeaderTab"
            >
              <i class="icon fa-file-text-o no-margin" aria-hidden="true"></i>
            </a>
          </li>
          <li class="nav-item" role="presentation" v-for="subForm in innerSubForms" ref="navLinksHolders">
            <a
              @click="_showSubForm(subForm, $event)"
              class="nav-link"
              data-toggle="tab"
              v-bind:class="{'active': subFormDefinition && subFormDefinition.Code === subForm.Code}"
              v-bind:href="'#'+subForm.Code"
              v-bind:aria-controls="'tab'+subForm.Code"
              role="tab"
              ref="navLinks"
            >
              {{ t(subForm.DictionaryKeyCode) }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="tab-content">
      <div :class="['tab-pane', 'panel-body', 'active', showPreloader ? 'hidden' : '']" id="exampleTabsOne" role="tabpanel">
        <div
        v-if="editorIcons.length || def.listImages.length"
        class="line d-md-none">
        <icons-render v-if="editorIcons.length" :propIcons="editorIcons"/>
        <!--      <images-render v-if="def.listImages.length" :propImages="def.listImages"/>-->
      </div>
        <div v-if="def.editorButtons.length && data && renderBaseForm" class="form-action-button-wrapper">
          <form-action-button
            :def="def"
            :buttonsDef="def.editorButtons"
            :propParent="this"
            :data="data"
            :enableSaveFormHook="true"
            @saveFormHook="triggerSaveFormHook"
            @actionSend="actionSend"
          />
        </div>

        <form-generator
          v-if="def.editor && renderBaseForm"
          @submit="formSubmit"
          @callBusinessRules="callBusinessRules"
          @changeValue="_formChangedValue"
          :fields="def.editor"
          :propsDefaults="data"
          :def="def"
          :updateDataRequest="() => {}"
          :formDataChanged="() => {}"
          :firstLevel="true"
          ref="form"
        />

        <grid-generator
          v-if="!renderBaseForm && subFormDefinition"
          :page="subFormDefinition.Code"
          :idStructure="subFormDefinition.idtEntityStructureFrom"
          :innerMenuField="{WhereCondition: subFormWhereCondition}"
          :row="data"
          :backRedirect="'self'"
          :parent="{ def: def, data: data }"
          :showH1="false"
          :propId="parseInt(this.data.id)"
          @dataLoaded="_dataLoadedListener"
          ref="grid"
        />

      </div>
    </div>

  </div>
</template>

<script>
import InputBox                                   from '../forms/elements/InputBox'
import SchedulerResource                          from '../../model/resource/scheduler.resource'
import { SchedulerEventValueObject }              from '../../model/value-objects/scheduler-event.value-object'
import Button                                     from '../grids/renderers/grid-form/elements/button'
import { SchedulerResourceValueObjectCollection } from '../../model/collection/scheduler-resource.value-object.collection'
import DefinitionGetter                           from '../../model/resource/getter/definitions-getter'
import FormGenerator                              from '../forms/FormGenerator'
import ValueTypeConverter                         from '../../model/converter/ValueTypeConverter'
import ResourceGetter                             from '../../model/resource/getter/resource-getter'
import FormActionButton                           from '../widgets/forms/form-action-button'
import Swal                                       from 'sweetalert2'
import FormDataChangeHelper                       from '../../model/helper/forms/form-data-change-helper'
import IconsRender                                from '../templates/widgets/icons-render'
import ImagesRender                               from '../templates/widgets/images-render'
import PDELinkGenerator                           from '../../model/wrapper/pde-link-params'
import GridGenerator                              from '../grids/grid-generator'

export default {
  name:       'scheduler-event-form',
  components: {
    Button,
    InputBox,
    FormGenerator,
    FormActionButton,
    IconsRender,
    ImagesRender,
    GridGenerator
  },
  props:      {
    eventValueObject:   {
      type:    SchedulerEventValueObject,
      default: function () {
        return null
      }
    },
    resourceCollection: {
      type:    SchedulerResourceValueObjectCollection,
      default: function () {
        return new SchedulerResourceValueObjectCollection()
      }
    },
    defArgs:            {
      type:    Object,
      default: function () {
        return null
      }
    },
    moveCalRec:         {
      type:    String,
      default: function () {
        return null
      }
    }
  },
  data () {
    return {
      def:                       null,
      data:                      {},
      originalData:              {},
      innerSubForms:             {},
      businessRuleCallStack:     [],
      dataChanged:               false,
      closeModal:                false,
      editorIcons:               [],
      renderForm:                false,
      showSaveConfirm:           false,
      saveFormHookCallback:      null,
      afterSaveFormHookCallback: null,
      renderBaseForm:            false,
      showPreloader:             true,
      subFormDefinition:         undefined,
      subFormWhereCondition:     '',
      subFormDefinitionFired:    false,
      formDataCheckFunction:     null
    }
  },
computed: {
  headerCode() {
    if (!this.def || !this.def._headers) {
      return null
    }
    return this.def._headers.split(',')[0]
  },
  subHeaders() {
    if (!this.def || !this.def._headers) {
      return []
    }
    const subHeadersSplitted = this.def._headers.split(',').slice(1)
    return subHeadersSplitted.map((header) => {
      try {
        return JSON.parse(this.originalData[header])
      } catch (e) {
        return this.originalData[header]
      }
    })
  }
},

  async created () {
    if (!this.eventValueObject) {
      throw new Error('Props eventValueObject is not set!')
    }

    await this.initDef()
    await this.initData()
    this._initFormDataCheckFunction()
    this.def.filterByData(this.data)
    this.editorIcons   = this.def.getEditorIcons(this.data)
    this.innerSubForms = this.def.subForms

    this.renderForm = true
  },

  mounted () {
    $(document).on('keydown', 'input, select', function (e) {
      if (!e.ctrlKey && e.key === 'Enter') {
        var self = $(this),
            form = self.parents('.vue-component-holder:eq(0)'),
            focusable,
            next

        focusable = form.find(
          'input:not([disabled="disabled"]):not(.tt-hint),select:not([tabindex="-98"]),textarea,button')
                        .filter(':visible')
        next      = focusable.eq(focusable.index(this) + 1)
        if (next.length) {
          const parent = next.parent()
          if (parent.hasClass('bootstrap-select')) {
            parent.find('button').trigger('click')
          }

          next.focus().select()
        }
        else {
          form.submit()
        }
        return false
      }
    })

    $(document).on('keydown', (e) => {
      if (e.ctrlKey && e.key === 'Enter') {
        const button = $(document).find('.btn-save-data')

        if (button.length) {
          this.showSaveConfirm = true
          button.trigger('click')
        }

        return false
      }

if (e.key === 'Escape') {
  console.log('1. ESC pressed - start')
  const button = $(document).find('.btn-close')
  console.log('2. Button found:', button.length)

  if (button.length) {
    console.log('3. Triggering button click')
    button.trigger('click')
  }

  console.log('4. Calling _back()')
  this._back()
  return false
}
    })

    $(document).on('click', '.panel-title', (e) => {
      const $this  = $(e.target),
            parent = $this.closest('.row'),
            showed = parent.find('.panel-collapse.show')

      if (showed.length) {
        $(showed[0]).collapse('toggle')
      }
    })
  },

  beforeDestroy () {
    $(document).off('keydown')
    $(document).off('keydown', 'input, select')
    $(document).off('click', '.panel-title')
  },

  watch: {
    async '$route' (args) {
      // this.showPreloader = true
      //
      // await this.initDef()
      // await this.initData()
      //
      // this.def.filterByData(this.data)
      // this.editorIcons   = this.def.getEditorIcons(this.data)
      // this.innerSubForms = this.def.subForms
      //
      // this.renderForm = true
      //
      // console.log(this.renderBaseForm)
    }
  },

  methods: {
    initDef () {
      let args = {
        code:                   this.defArgs.code,
        idtEntityStructureFrom: this.defArgs.idStructure
      }

      return DefinitionGetter
        .getDataDefinition(
          args,
          (def) => {this.def = def},
          (error) => {this.handleApiError(error)})
    },

    async initData () {
      const response = await ResourceGetter
        .get(this.def.viewName)
        .setDef(this.def)
        .getById(this.eventValueObject.id)

      this.data = Object.assign(
        {
          idLogUser:         this.$user.id,
          ResourceTable:     this.resourceCollection.getResourceTable(this.eventValueObject.idUserGroup),
          ResourceTableFrom: this.resourceCollection.getResourceTable(this.eventValueObject.originalResourceId),
          ResourceIDFrom:    this.eventValueObject.originalResourceId
        },
        this.eventValueObject.toApiObjectUpperCased(),
        response.data[0]
      )

      this.originalData   = Object.assign({}, this.data)
      this.showPreloader  = false
      this.renderBaseForm = true

      if (this.moveCalRec) {
        Promise
          .all(this.businessRuleCallStack)
          .then(async () => {
            await this.callMoveCalRec()
            this.dataChanged = true
          })
      }
    },

    submit (closeModal = true, showSaveConfirm = false) {
      this.closeModal      = closeModal
      this.showSaveConfirm = showSaveConfirm

      this.$refs.form.submit()
    },

    async formSubmit (data) {
      const resource = ResourceGetter
        .get(this.def.viewName)
        .setDef(this.def)

      if (this.def.afterSaveRec) {
        resource.afterSaveRec = this.def.afterSaveRec
      }

      try {
        if (this.saveFormHookCallback !== null) {
          const result              = await this.saveFormHookCallback()
          this.saveFormHookCallback = null
          if (!result) {
            this.afterSaveFormHookCallback = null
            return
          }
        }

        if (this.def.valRec) {
          let value = Object.assign({}, this.data)
          Object.keys(data.data).map(key => {
            value[key] = data.data[key]
          })

          let ruleParams = {
            ruleType: 'VALREC',
            ruleName: this.def.valRec,
            where:    this.subFormWhereCondition, // potreba upravit
            value:    value
          }

          const response = await resource.setDef(this.def).callBusinessRule(ruleParams)

          Object.keys(response.data.values).map(key => {
            data.data[key] = response.data.values[key]
          })

          this.def.filterByData(this.data)
          if (this.$refs.form) {
            this.$refs.form.changeEelement(this.def.dataFilters)
          }
          this.editorIcons = this.def.getEditorIcons(this.data)

          if (response.data.messages) {
            Swal.fire(response.data.messages, '')
          }
        }

        const response = await resource.update(data)

        if (this.afterSaveFormHookCallback !== null) {
          await this.afterSaveFormHookCallback()
          this.afterSaveFormHookCallback = null
        }

        if (this.closeModal) {
          this.$parent.$modal.hide('test')
        }

        if (this.showSaveConfirm) {
          this.showSaveConfirm = false

          Swal.fire(
            {
              icon:              'success',
              title:             this.$translate.text('title_saved'),
              text:              ' ',
              timer:             1500,
              showConfirmButton: false
            })
        }
        else {
          this.closeModal = true
        }
        this.$emit('updateEvent', this.eventValueObject)
        this.data         = Object.assign({}, response.data[0])
        this.originalData = Object.assign({}, response.data[0])
        this.dataChanged  = false
      }
      catch (error) {
        this.handleApiError(error)
      }
    },

    detailListener () {
      if (!this.eventValueObject.entityCode || !this.eventValueObject.id) {
        return
      }

      this.$router.push({
        name:   'PageDynamicEditor',
        params: { page: this.eventValueObject.entityCode, idStructure: '0', id: this.eventValueObject.id, redir: 'grid' }
      })
    },

    deleteListener () {
      SchedulerResource
        .delete(this.eventValueObject)
        .then((response) => {
          this.$parent.$modal.hide('test')
          this.$emit('removeEvent', this.eventValueObject)
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },

    cancelListener () {
      if (this.dataChanged) {
        let module  = this,
            message = this.$translate.text('cfm_save_changes_info')

        if (!this.id) {
          message = this.$translate.text('cfm_continue_save_changes')
        }

        Swal
          .fire({
            icon:              'question',
            title:             this.$translate.text('cfm_save_changes'),
            text:              message,
            showCancelButton:  true,
            showCloseButton:   true,
            cancelButtonText:  this.$translate.text('cfm_No'),
            confirmButtonText: this.$translate.text('cfm_Yes'),
            reverseButtons:    true
          })
          .then((result) => {
            if (result.value === true) {
              this.submit()
              this.$emit('cancel', this.eventValueObject)
              this.$modal.hide('test')
            }
            if (result.dismiss === 'cancel') {
              this.$emit('cancel', this.eventValueObject)
              this.$modal.hide('test')
            }
          })
      }
      else {
        this.$emit('cancel', this.eventValueObject)
        this.$modal.hide('test')
      }
    },

    // @TODO: potreba zrefaktorovat - na dvou mistech
    // stejny kod v PageDynamicEditor.js::_callBusinessRules
    callBusinessRules (args) {
      let formCalrecCallback = (originalValue = null, changeValueNextCalrec = false) => {
        // volani calrec nad celym formularem pokud je definovan
        if (this.def.calRec) {
          originalValue = originalValue === null && this.originalData.hasOwnProperty(args.element.field)
            ? this.originalData[args.element.field]
            : originalValue

          if (originalValue === null) {
            originalValue = ''
          }

          if (args.value === originalValue) {
            return
          }

          Object.assign(this.data, this.$refs.form._prepareSubmitData())

          if (args && changeValueNextCalrec) {
            this.data[args.element.field]         = args.value
            this.originalData[args.element.field] = args.value
          }

          let where = this.subFormWhereCondition
          if (!where && this.def.whereCondition) {
            where = this.def.whereCondition.replace(
              '%IDLOGUSER%', this.data.ID)
          }

          let options = {
                ruleType:   'CALREC',
                ruleName:   this.def.calRec,
                where:      where,
                columnName: args
                              ? args.element.field
                              : null,
                value:      this.data
              },
              promise = ResourceGetter
                .get(this.def.viewName)
                .setDef(this.def)
                .callBusinessRule(options)
                .then((response) => {
                  Object
                    .keys(response.data.values)
                    .map(key => {
                      let stValue = response.data.values['ST' + key]
                            ? response.data.values['ST' + key]
                            : response.data.values[key],
                          values  = {
                            value:   response.data.values[key],
                            stValue: stValue
                          }

                      if (this.$refs.form) {
                        this.$refs.form.setValue(key, values)
                      }

                      this.data[key] = response.data.values[key]
                      // this.originalData[key] = response.data.values[key]
                    })

                  this.def.filterByData(this.data)
                  this.buttonsDef = this.def.editorButtons
                  if (this.$refs.form) {
                    this.$refs.form.changeEelement(this.def.dataFilters)
                  }
                  this.editorIcons = this.def.getEditorIcons(this.data)

                  if (response.data.messages) {
                    Swal.fire(response.data.messages, '')
                  }

                }).catch((error) => {
                  this.handleApiError(error)
                })

          this.businessRuleCallStack.push(promise)
        }
      }

      if (!args) {
        formCalrecCallback()
        this.dataChanged = this.checkIfDataChanged()

        return
      }

      // volani calrec nad elementem formulare pokud je definovan
      if (args.element.calrec) {
        Object.assign(this.data, this.$refs.form._prepareSubmitData())
        let value = args.value

        let originalValue = this.originalData.hasOwnProperty(args.element.field)
          ? this.originalData[args.element.field]
          : ''

        if (originalValue === null) {
          originalValue = ''
        }

        if (value === originalValue) {
          return
        }

        args.element.type = args.element.dataType // TODO: hack -> v
                                                  // FormValuesCollection je
                                                  // treba predelat propertu
                                                  // type na dataType !!

        if (args.element.dataType === 'nvarchar'
          && args.hasOwnProperty('stValue')
          && (args.element.field === args.element.fieldView)) {
          value = args.stValue
        }
        else {
          value = ValueTypeConverter.convert(args.element, value)
        }

        this.data[args.element.field] = value
        // this.originalData[args.element.field] = value

        let options = {
              ruleType:   'CALREC',
              ruleName:   args.element.calrec,
              where:      this.subFormWhereCondition,
              columnName: args.element.field,
              value:      this.data
            },
            promise = ResourceGetter
              .get(this.def.viewName)
              .setDef(this.def)
              .callBusinessRule(options)
              .then((response) => {
                let changeValueNextCalrec = !!response.data.values.length
                Object
                  .keys(response.data.values)
                  .map(key => {
                    let stValue = response.data.values['ST' + key]
                          ? response.data.values['ST' + key]
                          : response.data.values[key],
                        values  = {
                          value:   response.data.values[key],
                          stValue: stValue
                        }

                    this.$refs.form.setValue(key, values)
                    this.data[key] = response.data.values[key]

                    if (args.element.field === key) {
                      changeValueNextCalrec = false
                    }
                    // this.originalData[key] = response.data.values[key]
                  })

                this.def.filterByData(this.data)
                this.buttonsDef = this.def.editorButtons
                if (this.$refs.form) {
                  this.$refs.form.changeEelement(this.def.dataFilters)
                }
                this.editorIcons = this.def.getEditorIcons(this.data)

                if (response.data.messages) {
                  Swal.fire(response.data.messages, '')
                }

                formCalrecCallback(originalValue, changeValueNextCalrec)
                this.dataChanged = this.checkIfDataChanged()

              }).catch((error) => {
                // nastaveni puvodni hodnoty pokud dojde k nejakemu problemu
                let originalValue = this.$refs.form
                                        .getOriginalValues()
                                        .getValue(args.element.field)
                this.$refs.form
                    .setValue(args.element.field, { value: originalValue })

                this.handleApiError(error)
              })

        this.businessRuleCallStack.push(promise)

        return
      }

      formCalrecCallback()
      this.dataChanged = this.checkIfDataChanged()
    },

    async callMoveCalRec () {
      const options = {
        ruleType:   'CALREC',
        ruleName:   this.moveCalRec,
        where:      null,
        columnName: null,
        value:      this.data
      }

      try {
        const response = await ResourceGetter
          .get(this.def.viewName)
          .setDef(this.def)
          .callBusinessRule(options)

        if (response.data.messages) {
          Swal.fire(response.data.messages, '')
        }

        Object
          .keys(response.data.values)
          .map(key => {
            let stValue = response.data.values['ST' + key]
                  ? response.data.values['ST' + key]
                  : response.data.values[key],
                values  = {
                  value:   response.data.values[key],
                  stValue: stValue
                }

            if (this.$refs.form) {
              this.$refs.form.setValue(key, values)
            }
          })

        this.data = Object.assign(
          this.eventValueObject.toApiObjectUpperCased(),
          this.data,
          response.data.values
        )

        // this.originalData = Object.assign({}, this.data)
        this.dataChanged = this.checkIfDataChanged()
      }
      catch (e) {
        this.$parent.$modal.hide('test')
        this.$emit('updateEvent', this.eventValueObject)
        this.handleApiError(e)
      }

    },

    async actionSend (data) {
      const response = await ResourceGetter
        .get(this.def.viewName)
        .setDef(this.def)
        .getById(data.ID)

      this.data = Object.assign(
        this.data,
        response.data[0]
      )

      this.originalData = Object.assign(
        {},
        this.data
      )

      this.dataChanged = this.checkIfDataChanged()

      for (const key of Object.keys(this.data)) {
        let stValue = response.data.values['ST' + key]
          ? response.data.values['ST' + key]
          : response.data.values[key]

        this.$refs.form.setValue(key, {
          value:   this.data[key],
          stValue: stValue
        })
      }

      this.def.filterByData(this.data)
      this.buttonsDef = this.def.editorButtons
      if (this.$refs.form) {
        this.$refs.form.changeEelement(this.def.dataFilters)
      }
      this.editorIcons = this.def.getEditorIcons(this.data)
    },

    triggerSaveFormHook (saveFormHookCallback, afterSaveFormHookCallback) {
      this.saveFormHookCallback      = saveFormHookCallback
      this.afterSaveFormHookCallback = afterSaveFormHookCallback
      this.submit(false)
    },

    _formChangedValue (args) {
      if (args.element) {
        this.data[args.element.field] = args.value
      }

      this.dataChanged = this.checkIfDataChanged()
    },

    checkIfDataChanged () {
      const data         = Object.assign({}, this.data)
      const originalData = Object.assign({}, this.originalData)

      delete data['CURRENTLONGITUDE']
      delete data['CURRENTLATITUDE']
      delete originalData['CURRENTLONGITUDE']
      delete originalData['CURRENTLATITUDE']

      for (const key in data) {
        if (data[key] === 0 || originalData[key] === 0) {
          data[key]         = null
          originalData[key] = null
        }

        if (typeof originalData[key] === 'undefined') {
          originalData[key] = null
        }

        if (data[key] === '') {
          data[key] = null
        }

        if (originalData[key] === '') {
          originalData[key] = null
        }

        if (typeof data[key] === 'string') {
          data[key] = data[key].replaceAll('\\/', '/')
        }

        if (typeof originalData[key] === 'string') {
          originalData[key] = originalData[key].replaceAll('\\/', '/')
        }

        if (data[key] !== originalData[key]) {
          // console.log(key, data[key], originalData[key])
          return true
        }
      }

      return false
    },

    _showSubForm (subFormDefinition, event) {
      this.changeUrlDisabled = true
      this.form              = this.$refs.form

      let success = () => {
        if (event) {
          this.subFormDefinitionFired = true
        }

        let whereCondition = ''

        if (subFormDefinition.hasOwnProperty('WhereCondition')) {
          whereCondition = subFormDefinition.WhereCondition
        }

        whereCondition = whereCondition.replace('%ID%', this.data.ID)

        this.renderBaseForm        = false
        this.rowData               = null
        this.subFormDefinition     = subFormDefinition
        this.subFormWhereCondition = whereCondition
        this.listIcons             = []
        this.listImages            = []
        this.buttonsDef            = []
        this.editorIcons           = []

        if (subFormDefinition.ViewName === 'tAttachment' &&
          this._showDownloadButton) {
          this.showDownload = true
        }
      }

      this.formDataCheckFunction(success, this.id ? success : null)
    },

    _initFormDataCheckFunction () {
      this.formDataCheckFunction = (
        success, cancel = null, forceSuccess = false, successRedir = false) => {
        if (this.submitTriggered) {
          this.submitTriggered = false
          success()

          return
        }

        let formDataChange = this.checkIfDataChanged()

        if (formDataChange) {
          let module  = this,
              message = this.$translate.text('cfm_save_changes_info')

          if (!this.id) {
            message = this.$translate.text('cfm_continue_save_changes')
          }

          Swal
            .fire({
              icon:              'question',
              title:             this.$translate.text('cfm_save_changes'),
              text:              message,
              showCancelButton:  true,
              showCloseButton:   true,
              cancelButtonText:  this.$translate.text('cfm_No'),
              confirmButtonText: this.$translate.text('cfm_Yes'),
              reverseButtons:    true
              // onAfterClose:      () => {
              //   if (!window.location.hash) {
              //     $('#tab-holder li a:first').addClass('active')
              //     $('#tab-holder li a:not(:first)').removeClass('active')
              //     $('#tab-holder li a:not(:first)').focus()
              //   }
              // }
            })
            .then((result) => {
              if (result.value && result.value === true) {
                if (!module.id &&
                  (this.parentParsed && this.parentParsed.length > 1)) {

                  this._submit()
                  return
                }

                module.subFormDefinitionFired = false
                module.submitSuccessCallbacks = []
                module.setRowData             = false

                if ((module.id || forceSuccess)) {
                  module.$refs.form.submit()
                  module.submitSuccessCallbacks.push((data) => {
                    // redirect to now created new row
                    if (successRedir) {
                      PDELinkGenerator.defaults = data.data
                      PDELinkGenerator.redir    = module.backRedirect
                      module.$router.replace(
                        PDELinkGenerator.getParams(module.def))
                    }

                    if (typeof success === 'function') {
                      success(data)
                    }
                  })
                  return
                }

                if (!module.id) {
                  this._submit(true)
                  module.submitSuccessCallbacks.push(() => {

                    // PDELinkGenerator.defaults = module.innerDefaults
                    // PDELinkGenerator.hash     = window.location.hash
                    // PDELinkGenerator.redir    = 'grid'
                    //
                    // module
                    //   .$router
                    //   .push(PDELinkGenerator.getParams(module.def))
                    success()

                  })

                  return
                }

                module.submitSuccessCallbacks.push(() => {
                  success()
                })
              }
              if (result.dismiss &&
                (result.dismiss === 'cancel' || result.dismiss ===
                  'backdrop')) {
                if (cancel) {
                  cancel()
                }
                else {
                  $('#tab-holder li a:first').addClass('active')
                  $('#tab-holder li a:not(:first)').removeClass('active')
                  this.subFormDefinitionFired = false
                  // window.location.hash        = ''
                }
              }
            })
        }
        else {
          success()
        }
      }
    },

    _renderBaseForm () {
      // window.location.hash = ''

      this.def.filterByData(this.data)
      this.editorIcons   = this.def.getEditorIcons(this.data)

      this.subFormDefinition      = null
      this.subFormDefinitionFired = false
      this.changeUrlDisabled      = false
      this.showDownload           = false
      this.renderBaseForm         = true
    },

    _dataLoadedListener () {
      this.showPreloader = false
    }
  }
}
</script>

<style scoped>
.modal-header .page-title {
  font-weight: bold;
  color: #76797b;
}
</style>

<style>

.v--modal-overlay .v--modal-box {
  margin-top: 50px;
}

.sched-form-wrap {
  margin: 20px;
}

.modal-header {
  padding: 0;
  margin-bottom: 0;
  justify-content: space-between;
}

.modal-header span {
  font-weight: 400;
  /* font-size: 18px; */
}

.modal-header .btn-success {
  margin: 0;
}

.modal-header .dropdown-menu .btn-success {
  margin: auto;
}

.modal-header button {
  margin-right: 3px;
}

.sched-form-wrap {
  min-height: 100vh;
}

.sched-form-wrap .vue-component-holder {
  height: auto;
}

.sched-form-wrap .vue-component-holder .row {
  margin-left: 0;
  margin-right: 0;
}

.sched-form-wrap .btn-icon.btn-primary i.icon {
  font-weight: 600;
  font-size: 18px;
  margin-top: 2px;
}

.sched-form-wrap .btn-icon.btn-primary {
  padding: .500rem .650rem;
}

.sched-form-wrap .form-element {
  padding: 0;
}

.sched-form-wrap .nav-tabs-horizontal {
  display: flex;
  width: 100%;
}

.vue-component-holder.dashboard .row.row-scheduler:not(.row-kpi) .sched-form-wrap .panel-body {
  overflow-y: inherit;
  height: auto !important;
  padding-left: 0;
  padding-right: 0;
}

</style>
